import {
  Button,
  Icon,
  ParagraphSVG,
  BoldSVG,
  ItalicSVG,
  UnderlineSVG,
  BulletListSVG,
  UndoSVG,
  RedoSVG,
} from "@newsela/angelou";
import PropTypes from "prop-types";

import NumberedListIcon from "@/icons/NumberedListIcon";
import { buttonsStyle } from "./Buttons.style";

const propTypes = {
  editor: PropTypes.object,
};

const ParagraphButton = ({ editor }) => {
  const isActive = editor.isActive("paragraph");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().setParagraph().run()}
    >
      <Icon
        SvgComponent={ParagraphSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Paragraph"
      />
    </Button>
  );
};

const Heading1Button = ({ editor }) => {
  const isActive = editor.isActive("heading", { level: 1 });
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      aria-label="Heading 1"
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
    >
      H1
    </Button>
  );
};

const Heading2Button = ({ editor }) => {
  const isActive = editor.isActive("heading", { level: 2 });
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      aria-label="Heading 2"
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
    >
      H2
    </Button>
  );
};

const Heading3Button = ({ editor }) => {
  const isActive = editor.isActive("heading", { level: 3 });
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      aria-label="Heading 3"
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
    >
      H3
    </Button>
  );
};

const FontBoldButton = ({ editor }) => {
  const isActive = editor.isActive("bold");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      disabled={!editor.can().chain().focus().toggleBold().run()}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleBold().run()}
    >
      <Icon
        SvgComponent={BoldSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Bold"
      />
    </Button>
  );
};

const FontItalicButton = ({ editor }) => {
  const isActive = editor.isActive("italic");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      disabled={!editor.can().chain().focus().toggleItalic().run()}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleItalic().run()}
    >
      <Icon
        SvgComponent={ItalicSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Italic"
      />
    </Button>
  );
};

const FontUnderlineButton = ({ editor }) => {
  const isActive = editor.isActive("underline");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      disabled={!editor.can().chain().focus().toggleUnderline().run()}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
    >
      <Icon
        SvgComponent={UnderlineSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Underline"
      />
    </Button>
  );
};

const BulletListButton = ({ editor }) => {
  const isActive = editor.isActive("bulletList");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleBulletList().run()}
    >
      <Icon
        SvgComponent={BulletListSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Bulleted list"
      />
    </Button>
  );
};

const OrderedListButton = ({ editor }) => {
  const isActive = editor.isActive("orderedList");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleOrderedList().run()}
    >
      <NumberedListIcon
        isDecorative={false}
        size={Icon.sizes.md}
        title="Ordered list"
      />
    </Button>
  );
};

const BlockQuoteButton = ({ editor }) => {
  const isActive = editor.isActive("blockquote");
  return (
    <Button
      __cssFor={{ root: buttonsStyle(isActive) }}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().toggleBlockquote().run()}
    >
      blockquote
    </Button>
  );
};

const UndoButton = ({ editor }) => {
  return (
    <Button
      __cssFor={{ root: buttonsStyle(false) }}
      disabled={!editor.can().chain().focus().undo().run()}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().undo().run()}
    >
      <Icon
        SvgComponent={UndoSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Undo"
      />
    </Button>
  );
};

const RedoButton = ({ editor }) => {
  return (
    <Button
      __cssFor={{ root: buttonsStyle(false) }}
      disabled={!editor.can().chain().focus().redo().run()}
      flavor={Button.flavors.incognito}
      onClick={() => editor.chain().focus().redo().run()}
    >
      <Icon
        SvgComponent={RedoSVG}
        isDecorative={false}
        size={Icon.sizes.md}
        title="Redo"
      />
    </Button>
  );
};

ParagraphButton.propTypes = propTypes;
Heading1Button.propTypes = propTypes;
Heading2Button.propTypes = propTypes;
Heading3Button.propTypes = propTypes;
FontBoldButton.propTypes = propTypes;
FontItalicButton.propTypes = propTypes;
FontUnderlineButton.propTypes = propTypes;
BulletListButton.propTypes = propTypes;
OrderedListButton.propTypes = propTypes;
BlockQuoteButton.propTypes = propTypes;
UndoButton.propTypes = propTypes;
RedoButton.propTypes = propTypes;

export {
  ParagraphButton,
  Heading1Button,
  Heading2Button,
  Heading3Button,
  FontBoldButton,
  FontItalicButton,
  FontUnderlineButton,
  BulletListButton,
  OrderedListButton,
  BlockQuoteButton,
  UndoButton,
  RedoButton,
};
